<template>
  <sec-cta-card heading-id="about-score-cta" :title="cta.title" :text="cta.text" :actions="cta.actions" />
</template>

<script setup>
import SecCtaCard from '@/components/security/ui/SecCtaCard.vue';
import { ABOUT } from '@/content/security/about';

const cta = ABOUT.scoreCta;
</script>
